/**
 * TODO: use this enum
 * import {ApplicationContextType} from "@wix/editor-platform-contexts";
 */
export enum ApplicationType {
  EditorAddon = 'EDITOR_ADDON',
  Platform = 'PLATFORM',
}
